import { render, staticRenderFns } from "./LawyerRegister.vue?vue&type=template&id=95aa5236&"
import script from "./LawyerRegister.vue?vue&type=script&lang=js&"
export * from "./LawyerRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports